var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.584 3.16602H21.0158C26.1794 3.16602 28.7612 3.16602 30.5541 4.42925C31.0678 4.79119 31.5239 5.22043 31.9085 5.70392C33.2507 7.39141 33.2507 9.82133 33.2507 14.6812V18.7115C33.2507 23.4032 33.2507 25.749 32.5082 27.6226C31.3145 30.6346 28.7902 33.0104 25.5899 34.1339C23.5992 34.8327 21.1068 34.8327 16.1219 34.8327C13.2733 34.8327 11.8491 34.8327 10.7115 34.4334C8.88282 33.7914 7.44034 32.4338 6.75826 30.7126C6.33398 29.642 6.33398 28.3015 6.33398 25.6206V18.9993",
    stroke: "#23272E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2493 18.999C33.2493 21.9139 30.8864 24.2768 27.9716 24.2768C26.9174 24.2768 25.6746 24.0921 24.6497 24.3667C23.739 24.6107 23.0277 25.322 22.7837 26.2327C22.5091 27.2576 22.6938 28.5004 22.6938 29.5546C22.6938 32.4694 20.3309 34.8324 17.416 34.8324",
    stroke: "#23272E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4167 9.49935L4.75 9.49935M11.0833 3.16602V15.8327",
    stroke: "#23272E",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileAdd);
export default __webpack_public_path__ + "static/media/file-add.43351b46ae5f81e9e55c036e3fd96ca0.svg";
export { ForwardRef as ReactComponent };